import { render, staticRenderFns } from "./AddManage.vue?vue&type=template&id=0492537c&scoped=true&"
import script from "./AddManage.vue?vue&type=script&lang=js&"
export * from "./AddManage.vue?vue&type=script&lang=js&"
import style0 from "./AddManage.vue?vue&type=style&index=0&id=0492537c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492537c",
  null
  
)

export default component.exports